const sendMessage = {
    path: 'sendMessage',
    component: resolve => require(['@/pages/admin/message/singleShot/sendMessage/index.vue'], resolve),
    meta: {
        requireAuth: true
    },
}

export default sendMessage